import React from "react";
import HeaderWithHelp from "./HeaderWithHelp.jsx";

const YEAR_HELP = "Jahresumsatz (netto), nur Rechnungswerte.";
const CURRENT_HELP = "Umsatz des Bezugsjahres bis zum Stichmonat.";
const HR_HELP = "Hochrechnung: Umsatz des laufenden Jahres bis zum Stichmonat ÷ Stichmonat × 12.";

/**
 * Kopfzellen für die Jahres-, "bis Stichmonat"- und HR-Spalten - gemeinsam
 * für Gesamt, Drilldown, Vertreter × Monat, Kundenrangliste und Kundensicht,
 * damit Überschriften und Sichtbarkeit überall gleich funktionieren.
 * `currentLabel`/`hrLabel` kommen aus `referenceLabels()` (format.js): ist
 * eine der beiden ausdrücklich `null`, ist das Bezugsjahr abgeschlossen -
 * die jeweilige Spalte entfällt dann ganz (schnittstelle.md 7.2), zusätzlich
 * über `hideHr` abschaltbar (z. B. bei expliziter Monatsauswahl).
 */
export default function YearHeaderCells({pastYears, currentLabel, hrLabel, hideHr = false}) {
    return (
        <>
            {pastYears.map((year) => (
                <th key={year} className="text-end va-num-th">
                    <HeaderWithHelp help={YEAR_HELP}>{year}</HeaderWithHelp>
                </th>
            ))}
            {currentLabel !== null && currentLabel !== undefined && (
                <th className="text-end va-num-th">
                    <HeaderWithHelp help={CURRENT_HELP}>{currentLabel}</HeaderWithHelp>
                </th>
            )}
            {!hideHr && hrLabel !== null && hrLabel !== undefined && (
                <th className="text-end va-num-th">
                    <HeaderWithHelp help={HR_HELP}>{hrLabel}</HeaderWithHelp>
                </th>
            )}
        </>
    );
}
